import styled from 'styled-components';
import Theme from './Theme';

export const Title = styled.h1`
  font-size: 24px;
  font-weight: normal !important;
  letter-spacing: 0.3px;
  color: ${Theme.colors.text.title};
`;

export const Card = styled.div`
  display: flex;

  background-color: ${Theme.colors.surface};
  box-shadow: ${Theme.colors.boxShadow};
  border-radius: ${Theme.metrics.card.borderRadius}px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  
  height: ${Theme.metrics.header.height}px;
`;

export const CardHeader = styled(Header)`
  margin: ${Theme.metrics.margin.small}px ${Theme.metrics.margin.normal}px;
  color: ${Theme.colors.text.cardHeader};
`;

export const CardTitle = styled.div`
  font-size: ${Theme.fonts.h2.size}px;
  letter-spacing: ${Theme.fonts.h2.letterSpacing}px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  
  font-size: ${({ theme }) => theme.V2.fonts.footer.size}px;
  letter-spacing: ${({ theme }) => theme.V2.fonts.footer.letterSpacing};
  
  text-align: right;
`;

const Stylesheet = styled.div`
  font-family: ${Theme.fonts.family};

  h1 {
    font-size: ${Theme.fonts.h1.size}px;
    font-weight: ${Theme.fonts.h1.weight};
    letter-spacing: ${Theme.fonts.h1.letterSpacing}px;
  }

  h2 {
    font-size: ${Theme.fonts.h2.size}px;
    letter-spacing: ${Theme.fonts.h2.letterSpacing}px;
  }
  
  h3 {
    font-size: ${Theme.fonts.h3.size}px;
    letter-spacing: ${Theme.fonts.h3.letterSpacing}px;
  }

  h4 {
    font-size: ${Theme.fonts.h4.size}px;
    letter-spacing: ${Theme.fonts.h4.letterSpacing}px;
  }
  
  tbody > tr:not(:first-of-type) {
    border-top: 1px solid ${Theme.colors.table.separator};
  }
  
  th {
    color: ${Theme.colors.text.tableHeader};
  
    font-size: ${Theme.fonts.table.head.size}px;
    font-weight: ${Theme.fonts.table.head.weight};
    letter-spacing: ${Theme.fonts.table.head.letterSpacing}px;
  }

  body {
    font-size: ${Theme.fonts.body.size}px;
    letter-spacing: ${Theme.fonts.body.letterSpacing}px;
  }
`;

export default Stylesheet;



// WEBPACK FOOTER //
// ./src/statsradio/themes/v2/Stylesheet.js